'use strict';

import EmptyRouterView from '../../../app/views/EmptyRouterView.vue';

export const eventManageSettingRoutes = [
  {
    path: 'settings',
    name: 'event.manage.setting.edit',
    props: true,
    component: () => import('../views/ManageSettingView.vue'),
  },
];
